/*
 *   File : executed-sip.js
 *   Author : https://evoqins.com
 *   Description : Executed SIP card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';

// Components
import { Chip } from "../Others";

//Style
import style from "../../Styles/Component/card.module.scss";
import { Icon } from "../Icon";
import { _formattedAmount } from '../../Helper';

function ExecutedSIPCard(props) {

    const navigate = useNavigate();

    // handle navigate to creator detail page
    const _handleNavigateToCreatorDetail = () => {
        navigate("/explore/creator-detail", {
            state: {
                creator_id: Number(props.product.creator_id)
            }
        });
    };

    return (
        <div className={`${style.e_alphabasket_card_wrapper} cursor-pointer`}>
            <div className='e-bg-white border-radius-16'>
                <div data-type={props.product.strategy_type === "alpha_basket_pro" ? "basket-pro" : "basket"}
                    className={`${style.e_heading_wrapper} position-relative`}>
                    <img src={require(props.product.strategy_type === "alpha_basket_pro" ? "../../Assets/Images/Card/alphabasket-pro-tag.svg" : "../../Assets/Images/Card/alphabasket-tag.svg").default}
                        draggable={false}
                        className='position-absolute left--6px top-8px h-28'
                        alt='tag' />
                    <Chip label={props.product.risk_category_info.risk_category_name}
                        className={props.product.risk_category_info.risk_category_name === 'Conservative' ? 'e-text-deep-green e-bg-nyanza e-border-1px-light-green' :
                            props.product.risk_category_info.risk_category_name === 'Moderate' ? 'e-text-brown e-bg-lemon-chiffon e-border-1px-jasmine' :
                                'e-text-cadmium-purple e-bg-lavender-blush e-border-1px-light-red'} />
                </div>
                <div className='p-2 p-sm-3'>
                    <div className='d-flex align-items-center gap-12px pb-3 e-border-bottom-1px-anti-flash-white'>
                        <img src={props.product.strategy_logo}
                            draggable={false}
                            className='w-48px w-32px-res align-self-start'
                            alt='product' />
                        <div>
                            <p className='e-font-14-res mb-1 e-text-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px'>
                                {props.product.strategy_name}
                            </p>
                            <p className='e-font-12-res mb-0 e-text-philippine-gray e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px text-decoration-hover-underline'
                                onClick={_handleNavigateToCreatorDetail}>
                                {props.product.creator_info.creator_name}
                            </p>
                        </div>
                        {/* <div className='col-auto ms-auto align-self-start'>
                            <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                Order Amount
                            </p>
                            <p className={`e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px e-letter-spacing-min-point-1px`}>
                                {props.product.amount}
                            </p>
                        </div> */}
                    </div>

                    {/* SIP details */}
                    <div className='margin-12px-top'>
                        <div className='row pb-3  justify-content-between'>
                            <div className='col-auto'>
                                <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                    Date
                                </p>
                                <p className={`e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px e-letter-spacing-min-point-1px`}>
                                    {props.product.sip_start_date}
                                </p>
                            </div>
                            <div className='col-auto'>
                                {/* <p className='mb-2 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                    Order status
                                </p>
                                <p className={`d-flex gap-1 align-items-center mb-0 e-alt-font-lato e-font-14 e-font-weight-600 line-height-16px
                                        ${props.product.order_status === "Success" ? "e-text-go-green" : props.product.order_status === "Processing" ? "e-text-marigold" : "e-text-paradise-pink"}`}>
                                    <Icon icon={props.product.order_status === "Success" ? "success-icon" : props.product.order_status === "Processing" ? "processing-icon" : "failed-icon"}
                                        size="16px" />
                                    {props.product.order_status}
                                </p> */}

                                <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                    Order Amount
                                </p>
                                <p className={`e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px e-letter-spacing-min-point-1px`}>
                                    {_formattedAmount(props.product.amount)}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(ExecutedSIPCard);